import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap, flatMap } from 'rxjs/operators';
import { OversignTimeService } from '../oversign-time.service';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromOversign from './oversign-time.actions';
import * as fromShared from '../../shared';
import { DisplayMessageMinimum, IStatusMessage, ResponseStatus } from '../../shared';

@Injectable()
export class OversignTimeEffects {
    constructor(
        private actions$: Actions,
        @Inject(OversignTimeService) private service: OversignTimeService,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    getOversignTime$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromOversign.getOversignTimes),
            tap(a =>
                this.log.verbose({
                    type: 'OversignTimeEffects:getOversignTime$',
                    a
                })
            ),
            switchMap(a =>
                this.service.getOversignTime(a.EmployeeListID).pipe(
                    map(ot =>
                        fromOversign.loadOversignTimes({ oversignTimes: ot })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );

    putOversignTime$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromOversign.putOversignTimes),
            tap(a =>
                this.log.verbose({
                    type: 'OversignTimeEffects:putOversignTime$',
                    a
                })
            ),
            switchMap(a =>
                this.service.putOversignTime(a.oversignTime).pipe(
                    flatMap(ot => [
                        fromOversign.updateOversignTimes({
                            oversignTimes: [
                                {
                                    id: a.oversignTime
                                        .map(x => x.EmpTimeID)
                                        .toString(),
                                    changes: ot.Items[0]
                                }
                            ]
                        }),

                        fromOversign.getOversignTimes({
                            EmployeeListID: ot.Items[0].EmployeeListID
                        }),
                        new fromShared.Errors.RemoveErrors(
                            ot.Items
                                .filter(
                                    x =>
                                        x.Status.StatusCode ===
                                        ResponseStatus.Success
                                )
                                .map(x => x.EmpTimeID.toString())
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...ot.ErrorMessages.map(
                                    x =>
                                        ({
                                            StatusCode: -1,
                                            Message: x,
                                            MsgProcessID: 0,
                                            MsgEntityID: ''
                                        } as IStatusMessage)
                                ),
                                ...ot.Items.filter(
                                    x =>
                                        x &&
                                        x.Status.StatusCode >=
                                            DisplayMessageMinimum
                                ).map(x => x.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
